/*
 * Menú de secciones del tablero de Marcaciones. Cada opción cambia ?seccion= en la URL (el enlace se
 * puede compartir y el botón Atrás del navegador vuelve a la sección anterior). SECTION_ITEMS define
 * orden, texto e ícono (boxicons de la plantilla); sus claves son las de SECTIONS en utils/period.js.
 */
import React from "react";

export const SECTION_ITEMS = [
    {key: 'ingresos', label: 'Ingresos', icon: 'bx bx-log-in-circle'},
    {key: 'almuerzos', label: 'Almuerzos', icon: 'bx bx-restaurant'},
    {key: 'salidas', label: 'Salidas', icon: 'bx bx-log-out-circle'},
    {key: 'horas', label: 'Horas trabajadas', icon: 'bx bx-time-five'},
    {key: 'dashboard', label: 'Dashboard', icon: 'bx bx-bar-chart-alt-2'},
];

const SectionMenu = ({active, onSelect}) => (
    <nav className="mc-menu" aria-label="Secciones de marcaciones">
        {SECTION_ITEMS.map((item) => (
            <button key={item.key} type="button"
                    className={`mc-menu__item${item.key === active ? ' is-active' : ''}`}
                    aria-current={item.key === active ? 'page' : undefined}
                    onClick={() => onSelect(item.key)}>
                <i className={item.icon} aria-hidden="true"/>
                <span>{item.label}</span>
            </button>
        ))}
    </nav>
);

export default SectionMenu;
